export default __webpack_public_path__ + "static/media/Shrimp_textile_stocks.cedc551b.png";